"use client";

import { c as _c } from "react/compiler-runtime";
import { AccountLockup, AccountLockupText } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Item, ItemAvatar, ItemContent, Link } from "@opensea/next-ui-kit";
import { NumberDisplay, SkeletonBlock, TableCell, TableRow, TextBody, TextBodySkeleton, TextLabel } from "@opensea/ui-kit";
import { bn } from "@opensea/utils";
import { useTranslations } from "next-intl";
import { getProfileUrl } from "@/components/account/utils";
import { useAddress } from "@/hooks/wallet";
import { ITEM_OWNERS_TABLE_COLUMN_CLASSNAMES } from "./constants";
import { ItemOwnersTableRowFragment } from "./ItemOwnersTableRow.fragment";
export function ItemOwnersTableRow(t0) {
  const $ = _c(9);
  const {
    item: itemKey
  } = t0;
  const item = readFragment(ItemOwnersTableRowFragment, itemKey);
  const t = useTranslations("ItemOwnersTableRow");
  const connectedAddress = useAddress();
  if (!item) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ItemOwnersTableRowSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = getProfileUrl(item.owner);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TextBody weight="semibold"><AccountLockupText /></TextBody>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const T0 = TableCell;
  const t3 = ITEM_OWNERS_TABLE_COLUMN_CLASSNAMES;
  const T1 = TextLabel;
  const t4 = t.rich("items", {
    numberDisplay: () => <NumberDisplay display="quantity" value={item.quantity} />,
    count: bn(item.quantity).toNumber()
  });
  let t5;
  if ($[2] !== T1 || $[3] !== t4) {
    t5 = <T1>{t4}</T1>;
    $[2] = T1;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== T0 || $[6] !== t3.quantity || $[7] !== t5) {
    t6 = <T0 className={t3.quantity}>{t5}</T0>;
    $[5] = T0;
    $[6] = t3.quantity;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return <Link href={t1} variant="unstyled"><TableRow interactive={true}><TableCell className={ITEM_OWNERS_TABLE_COLUMN_CLASSNAMES.owner}><AccountLockup account={item.owner} addressDisplay="compact" connectedAddress={connectedAddress ?? null} isLink={false} withAvatar={true}>{t2}</AccountLockup></TableCell>{t6}</TableRow></Link>;
}
function ItemOwnersTableRowSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ItemAvatar className="size-6 rounded-full"><SkeletonBlock /></ItemAvatar>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TableCell className={ITEM_OWNERS_TABLE_COLUMN_CLASSNAMES.owner}><Item className="gap-2" variant="unstyled">{t0}<ItemContent><TextBodySkeleton className="w-[100px]" /></ItemContent></Item></TableCell>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TableRow>{t1}<TableCell className={ITEM_OWNERS_TABLE_COLUMN_CLASSNAMES.quantity}><TextBodySkeleton className="w-[80px]" /></TableCell></TableRow>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}